export function arrayRemoveDuplicates(items: any[]): any[] {
  return Array.from(new Set(items));
}

export function betragToCent(betrag: number) {
  return Math.round(betrag * 100);
}

export function betragToEuro(betrag: number) {
  return Math.round(betrag) / 100;
}

export function betragRound(betrag: number) {
  return Math.round(betrag);
  // to cent: return Math.round(betrag * 100) / 100;
}

export function betragToString(value: number): string {
  if (value == null) {
    return null;
  }
  if ((value * 100) % 100) {
    return value.toFixed(2).replace('.', ',') + '€';
  }
  return value + '€';
}
